import type { ChannelEntity } from '@/features/channel/domain/entities/ChannelEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'

export class ChannelUserFilterEntity {
  user?: UserMiniEntity
  channels?: ChannelEntity
  page?: number
  limit?: number
}
